import React, { useState } from "react";
import styled from "styled-components";
import { FaExternalLinkAlt, FaGithub } from "react-icons/fa";

const SectionTitle = styled.h3`
font-size: 1.5rem;
color: ${({ theme }) => theme.colors.primary};
margin-bottom: 1rem;
text-align: center;

@media (max-width: 768px) {
font-size: clamp(1.25rem, 5vw, 1.5rem);
margin-bottom: 1.5rem;
}
`;

const ProjectsWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
padding: 1rem;

@media (max-width: 768px) {
padding: 1rem 1.5rem;
}
`;

const ProjectsContainer = styled.div`
display: grid;
grid-template-columns: repeat(3, 1fr);
gap: 20px;
max-width: 1200px;

@media (max-width: 1024px) {
grid-template-columns: repeat(2, 1fr);
}

@media (max-width: 768px) {
grid-template-columns: 1fr;
gap: 16px;
}
`;

const ProjectCard = styled.div`
background-color: #112240;
width: 250px;
height: 250px;
padding: 1.5rem;
border-radius: 8px;
color: #ccd6f6;
transition: 
transform 0.3s ease,
box-shadow 0.3s ease,
border 0.3s ease;
display: flex;
flex-direction: column;
justify-content: space-between;
box-shadow: 0px 10px 30px -15px rgba(2, 12, 27, 0.7);
border: 2px solid transparent;

&:hover {
transform: translateY(-5px);
border: 2px solid ${({ theme }) => theme.colors.primary};
box-shadow: 0 0 15px ${({ theme }) => theme.colors.primary};
}

h4 {
margin: 0;
font-size: 1.2rem;
color: ${({ theme }) => theme.colors.primary};
transition: color 0.3s ease;

a {
color: inherit;
text-decoration: none;

&:hover {
color: ${({ theme }) => theme.colors.text};
}
}
}

.tags {
font-size: 0.8rem;
color: ${({ theme }) => theme.colors.text};
margin-top: auto;
line-height: 1.5;
}

.icons {
display: flex;
justify-content: flex-end;
align-items: center;
gap: 0.5rem;
margin-bottom: 1rem;

.linkIcon,
.githubIcon {
color: ${({ theme }) => theme.colors.primary};
font-size: 1rem;
cursor: pointer;
transition: 
color 0.3s ease,
transform 0.2s ease;

&:hover {
color: ${({ theme }) => theme.colors.text};
transform: translateY(-2px);
}
}
}

@media (max-width: 768px) {
width: 100%;
height: auto;
padding: 1.25rem;

h4 {
font-size: 1.1rem;
margin-bottom: 0.5rem;
}

.tags {
font-size: 0.8rem;
margin-top: 0.5rem;
}
}
`;

const ToggleButton = styled.button`
display: block;
background-color: ${({ theme }) => theme.colors.primary};
color: #ffffff;
padding: 10px 20px;
margin: 2rem auto 0;
border: none;
border-radius: 4px;
cursor: pointer;
font-weight: bold;
transition: 
background-color 0.3s ease,
transform 0.2s ease;

&:hover {
background-color: ${({ theme }) => theme.colors.text};
transform: translateY(-2px);
}

@media (max-width: 768px) {
padding: 10px 24px;
font-size: 0.9rem;
}
`;

const NoteworthyProjects = () => {
const [showAll, setShowAll] = useState(false);

const projects = [
{
title: "Expense Tracker",
tags: ["React", "Firebase", "Machine Learning", "Tailwind CSS"],
link: "https://expense-tracker-update-pi.vercel.app/",
github: "https://github.com/haile1713/Simple--Expense-tracker-app-with-ML-",
},
{
title: "Eco Tracker",
tags: ["React", "Next.js", "Drizzle", "Web3Auth", "Ethereum"],
github: "https://github.com/haile1713/EcoTrack",
},
{
title: "Match-3 Game",
tags: ["JavaScript", "HTML5", "CSS3", "Pixi.js"],
link: "https://match-3-nine.vercel.app/",
github: "https://github.com/haile1713/match-3",
},
{
title: "Snap2PDF",
tags: ["Python", "Tkinter", "PDF Generation"],
link: "https://drive.google.com/file/d/1MWf-J2pKDvBoK2Et7JSVg0zKKsUkfp27/view?usp=drive_link",
github: "https://github.com/haile1713/Snap2PDF",
},
{
title: "Nuclearn",
tags: ["Next.js", "React", "Tailwind CSS"],
github: "https://github.com/haile1713/nuclearn",
},
{
title: "Algorithm Visualized",
tags: ["Vite", "Tailwind CSS", "p5.js", "TypeScript"],
link: "https://algorithm-visualized.vercel.app/",
github: "https://github.com/haile1713/algorithm-visualized",
},
{
title: "Tetris Game",
tags: ["JavaScript", "Konva.js", "Game Development"],
github: "https://github.com/haile1713/Tetris--Konva",
},
{
title: "Bestie",
tags: ["Figma", "Flutter", "Firebase", "PostgreSQL"],
link: "https://www.figma.com/proto/ZXY8jEYI6c6zjA2cRyIiEj/Bestie?node-id=3-14&starting-point-node-id=3%3A14&t=50P36d0B2uQBod5p-1",
},
{
title: "Filega",
tags: ["Figma", "Flutter", "Express", "PostgreSQL"],
link: "https://www.figma.com/proto/oOxiDJHku9bZEiKT2fkL8F",
},
];

const displayedProjects = showAll ? projects : projects.slice(0, 3);

const toggleShow = () => {
setShowAll((prev) => !prev);
};

return (
<div>
<SectionTitle>Other Noteworthy Projects</SectionTitle>
<ProjectsWrapper>
<ProjectsContainer>
{displayedProjects.map((project, index) => (
<ProjectCard key={index}>
<div className="icons">
{project.link && (
<a
href={project.link}
target="_blank"
rel="noopener noreferrer"
aria-label="Live Link"
>
<FaExternalLinkAlt className="linkIcon" />
</a>
)}
{project.github && (
<a
href={project.github}
target="_blank"
rel="noopener noreferrer"
aria-label="GitHub Link"
>
<FaGithub className="githubIcon" />
</a>
)}
</div>
{project.link ? (
<a
href={project.link}
target="_blank"
rel="noopener noreferrer"
aria-label="Live Link"
>
<h4>{project.title}</h4>
</a>
) : (
<h4>{project.title}</h4>
)}
<div className="tags">{project.tags.join(" • ")}</div>
</ProjectCard>
))}
</ProjectsContainer>
</ProjectsWrapper>
<ToggleButton onClick={toggleShow}>
{showAll ? "Show Less" : "Show More"}
</ToggleButton>
</div>
);
};

export default NoteworthyProjects;

